'use client'

import AppContext from "AppContext";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { validate } from "components/validateGeneralForm";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Alert, Button, Card, CardBody, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, Row } from "reactstrap";
import equipeService from "services/EquipeService";
import { erroInesperado } from "services/Utils";
import Dados from "../../contratos/Form/Dados";
import Componentes from "./Componentes";
import ModalIncluir from "./Componentes/ModalIncluir";
import { MotivoDescarteEnumList } from "services/DescarteService";
import { DestinacaoMaterialDescarteEnumList } from "services/DescarteService";
import { MotivoDescarteEnum } from "services/DescarteService";
import { DestinacaoMaterialDescarteEnum } from "services/DescarteService";
import descarteService from "services/DescarteService";

export default function FormDescarte() {
  const [data, setData] = useState({})
  const [componentes, setComponentes] = useState([])
  const [configModalIncluir, setConfigModalIncluir] = useState()

  const navigate = useNavigate()

  const { state } = useContext(AppContext)

  const formConfig = useMemo(() => {
    return [
      [
        { name: 'titulo1', label: 'Identificação do Solicitante', type: "title", colspan: 12, disabled: true },
        { name: "solicitante.nome", label: "Nome", value: state.user.nome, type: "readonlytext", colspan: 12 },
        { name: "solicitante.empresa", label: "Empresa", value: state.user.empresa.razaoSocial, type: "readonlytext", colspan: 12 },
      ], [
        { name: 'titulo2', label: 'Identificação do Material', type: "title", colspan: 12, disabled: true },
        {
          name: 'material', type: 'view', component: () => {
            return (
              <Componentes items={componentes} onAdd={() => {
                setConfigModalIncluir({ inclusos: componentes.map(el => el.id) })
              }} onDelete={(item) => {
                setComponentes(componentes.filter(el => el.id != item.id))
              }} />
            )
          }
        }
      ], [
        { name: 'titulo3', label: 'Motivo do descarte', type: "title", colspan: 12, disabled: true },
        { name: "motivoDescarte", label: '', type: "radio", required: true, options: MotivoDescarteEnumList.map(el => ({ value: el.id, label: el.nome })), colspan: 6 },
        { name: "motivoDescarteOutro", label: '', type: "text", required: true, hide: data.motivoDescarte != MotivoDescarteEnum.OUTRO, colspan: 3, placeholder: 'Outro motivo' },
      ], [
        { name: 'titulo4', label: 'Forma de destinação', type: "title", colspan: 12, disabled: true },
        { name: "destinacaoMaterial", label: '', type: "radio", required: true, options: DestinacaoMaterialDescarteEnumList.map(el => ({ value: el.id, label: el.nome })), colspan: 12 },
        { name: "empresaResponsavelDescarte", label: 'Empresa Responsável', type: "text", required: true, hide: data.destinacaoMaterial != DestinacaoMaterialDescarteEnum.DESCARTE_HOMOLOGADO, colspan: 8 },
        { name: "certificadoDescarte", label: 'Certificado de Descarte', type: "radio", required: true, hide: data.destinacaoMaterial != DestinacaoMaterialDescarteEnum.DESCARTE_HOMOLOGADO, colspan: 4, options: [{ value: '1', label: 'Sim' }, { value: '0', label: 'Não' }] },
        { name: "proprietarioDevolucao", label: 'Nome do Proprietário', type: "text", required: true, hide: data.destinacaoMaterial != DestinacaoMaterialDescarteEnum.DEVOLUCAO_PROPRIETARIO, colspan: 12 },
        { name: "destinoSetorReutilizacao", label: 'Novo destino / setor', type: "text", required: true, hide: data.destinacaoMaterial != DestinacaoMaterialDescarteEnum.REUTILIZACAO, colspan: 12 },
      ], [
        { name: 'titulo5', label: 'Observações', type: "title", colspan: 12, disabled: true }, //textarea
        { name: "observacoes", label: '', type: "textarea", required: false, colspan: 12, style: { height: 100 } },
      ]
    ]
  }, [state, componentes, data])

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      console.log(errors)
      setData({ ...data, errors })
      return
    }

    if (componentes.length == 0) {
      toast.error('Inclua ao menos um componente para descarte')
      return
    }

    try {
      await descarteService.create(state.contrato.id, { ...data, componentes: componentes.map(el => el.id) })
      toast('Registro salvo com sucesso!')
      navigate(`/admin/descartes`)
    } catch (ex) {
      erroInesperado()
    }
  }

  const handleIncluir = async (item) => {
    setComponentes([...componentes, item])
    toast('Componente incluído com sucesso!')
  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Descartes" edit={true} showButton={false} />
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>


            <Dados data={data} onChange={handleChange} formConfig={formConfig} edit={true} />
            <div className="text-right">
              <Button type="submit" color="primary">Salvar</Button>
              <Button type="button" color="primary" outline onClick={() => navigate(-1)}>Voltar</Button>
            </div>
          </form>
          <ModalIncluir
            config={configModalIncluir}
            onClose={() => setConfigModalIncluir()}
            onSelect={handleIncluir}
          />

        </CardBody>
      </Card>
    </Container>
  )
}